import { useContext } from 'react'
import AuthProviderContext from './AuthProvider.context'

export const useAuthProvider = () => {
  return useContext(AuthProviderContext)
}
